export const TARGETS = [
    'VIP',
    'group',
    'crew',
    'beatAlert',
    'birthdate',
    'commercial',
] as const;
